import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import {
  apiError,
  getGateOutList,
  gateInListSuccessful,
  purchaseDocSuccessful,
  gateOutByIDSuccessful,
  vehicleDataSuccessful,
  purchasesImageUploadSuccessful,
  FormulaExecuterSuccessful,
  purchasesCheckApproveSuccessful,
  purchaseHistoryListSuccessful,
  saleHistoryListSuccessful,
  getPurchaseDoc,
  isRejectModelVisible,
  purchaseEnquirySuccessful,
  getPurchaseCheckApprove,
  repairAmountListSuccessful,
  reEstimationListSuccessful,
  InputChangeValue,
  addGateOutSuccessful,
  getGateInListByIdSuccessful,
  vehicleImagesByIDSuccessful,
  personOTPRequestSuccessful,
  personOTPResendSuccessful,
  verifyPersonOTPSuccessful,
  addGateOut,
} from "./gateOutSlice";
import { getVersionColors } from "../../mini/miniSlice";
import {
  getList,
  getParamsList,
  postAdd,
  postEdit,
  postFormData,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import { select } from "redux-saga/effects";
import { evaluate } from "mathjs";

import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
import { serialize } from "object-to-formdata";
//If user is login then dispatch redux action's are directly from here.
function* GateOutList({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      // if (k === "currentSort" || k === "sortOrder") {
      //   params.ordering = data.sortOrder + data.currentSort;
      // } else {
      if (data[k] != "" && k != null && k != "no_of_pages") {
        if (k == "start_date") {
          params[k] = moment(data[k]).format("YYYY-MM-DD");
        } else if (k == "end_date") {
          params[k] = moment(data[k]).format("YYYY-MM-DD");
        } else {
          params[k] = data[k];
        }
      }
      // }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/godown/gate_out/list/",
      params
    );
    yield put(gateInListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GateInListById({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      // if (k === "currentSort" || k === "sortOrder") {
      //   params.ordering = data.sortOrder + data.currentSort;
      // } else {
      if (data[k] != "" && k != null && k != "no_of_pages") {
        if (k == "start_date") {
          params[k] = moment(data[k]).format("YYYY-MM-DD");
        } else if (k == "end_date") {
          params[k] = moment(data[k]).format("YYYY-MM-DD");
        } else {
          params[k] = data[k];
        }
      }
      // }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      `/godown/gate_in/detail/${payload.status_id}/`
    );
    yield put(getGateInListByIdSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GateOutAdd({ payload }) {
  // Filter out null or empty values from gateOutObj
  const data = Object.entries(payload.purchaseObj || {}).reduce(
    (acc, [key, value]) => {
      if (value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    },
    {}
  );

  try {
    if (payload.purchaseObj.status_id == 0) {
      const { status_id, id, ...filteredGateOutObj } = payload.purchaseObj;

      // First API call: Create gate-out entry
      const response = yield call(
        postAdd,
        `/godown/gate_out/list/`,
        filteredGateOutObj
      );

      if (response.status === 201 && payload.profileObj) {
        if (payload.profileObj && Object.keys(payload.profileObj).length > 0) {
          const formData = serialize(payload.profileObj);
          console.log("response.", response);

          // Second API call: Upload vehicle images
          const response2 = yield call(
            postEdit,
            `/godown/gateoutvehicleimages/${response.data.id}`,
            formData
          );

          if (response2.status === 200 || response2.status === 201) {
            Modal.success({
              icon: (
                <span className="remix-icon">
                  <RiCheckboxCircleLine />
                </span>
              ),
              title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
              content: (
                <p className="hp-p1-body hp-text-color-black-80">
                  Gate Out added successfully!
                </p>
              ),
            });
          } else {
            Modal.error({
              icon: (
                <span className="remix-icon">
                  <RiAlertLine />
                </span>
              ),
              title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
              content: (
                <p className="hp-p1-body hp-text-color-black-80">
                  Unable to add Gate Out. Please try again!
                </p>
              ),
            });
          }
        } else {
          console.log("No vehicle images provided, skipping upload.");
        }

        window.location.assign("/pages/gateout");
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Unable to add Gate Out. Please try again!
            </p>
          ),
        });
      }
    } else {
      const { status_id, id, godown_vehicle_id, ...filteredGateOutObj } =
        payload.purchaseObj;

      // First API call: Update gate-out entry
      const response = yield call(
        postEdit,
        `/godown/gate_out/list/${payload.purchaseObj.status_id}/`,
        filteredGateOutObj
      );

      if (response.status === 200 && payload.profileObj) {
        if (payload.profileObj && Object.keys(payload.profileObj).length > 0) {
          const formData = serialize(payload.profileObj);

          // Second API call: Upload vehicle images
          const response2 = yield call(
            postEdit,
            `/godown/gateoutvehicleimages/${response.data.godown_vehicle.id}`,
            formData
          );

          if (response2.status === 200 || response2.status === 201) {
            Modal.success({
              icon: (
                <span className="remix-icon">
                  <RiCheckboxCircleLine />
                </span>
              ),
              title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
              content: (
                <p className="hp-p1-body hp-text-color-black-80">
                  Gate Out updated successfully!
                </p>
              ),
            });
          } else {
            Modal.error({
              icon: (
                <span className="remix-icon">
                  <RiAlertLine />
                </span>
              ),
              title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
              content: (
                <p className="hp-p1-body hp-text-color-black-80">
                  Unable to update Gate Out. Please try again!
                </p>
              ),
            });
          }
        } else {
          console.log("No vehicle images provided, skipping upload.");
        }

        window.location.assign("/pages/gateout");
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <p className="hp-p1-body hp-text-color-black-80">
              Unable to edit Gate Out. Please try again!
            </p>
          ),
        });
      }
    }

    yield put(addGateOutSuccessful(null));
  } catch (error) {
    console.log("error", error);
    if (error.response?.status === 400) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <p className="hp-p1-body hp-text-color-black-80">
            {error.response.data.error[0]}
          </p>
        ),
      });
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting server-side issue!
          </p>
        ),
      });
    }

    yield put(addGateOutSuccessful(null));
    yield put(apiError(error));
  }
}

// Gate Out Vehicle History List
function* PurchaseHistory({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/purchase/byvehicleid/" + payload.id,
      {}
    );
    yield put(purchaseHistoryListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Sale History List

function* SaleHistory({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/sale/byvehicleid/" + payload.id,
      {}
    );
    yield put(saleHistoryListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* purchaseEnquiry({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/purchase/enquiry/list/", data);
    yield put(purchaseEnquirySuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* PurchaseApproval({ payload }) {
  try {
    const response = yield call(postAdd, "/purchase/approve/", payload);
    if (response.status === 200) {
      if (payload.approvalstatus == 2) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your purchase has been approved successfully.
              </p>
            </div>
          ),
        });
      } else if (payload.approvalstatus == 3) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your purchase has been Rejected successfully.
              </p>
            </div>
          ),
        });
      }

      yield put(getPurchaseDoc(payload.purchase_id));
      yield put(getPurchaseCheckApprove({ purchase_id: payload.purchase_id }));
      yield put(isRejectModelVisible(false));
    } else {
      if (payload.approvalstatus == 2) {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to Approve Gate Out Vehicle. Please try again!
              </p>
            </div>
          ),
        });
      } else if (payload.approvalstatus == 3) {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to Reject Gate Out Vehicle. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}
function* PurchaseCheckApprove({ payload }) {
  try {
    const response = yield call(postAdd, "/purchase/checkapprove/", payload);
    if (response.status === 200) {
      yield put(purchasesCheckApproveSuccessful(true));
    }
  } catch (error) {
    yield put(purchasesCheckApproveSuccessful(false));
    yield put(apiError(error));
  }
}

function* PurchaseDoc({ payload }) {
  try {
    const response = yield call(getList, "/purchase/" + payload, {});
    yield put(purchaseDocSuccessful(response));
    yield put(getVersionColors(response.vehicle?.version?.model?.id));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* GetGateOutByID({ payload }) {
  try {
    const response = yield call(
      getList,
      `/godown/gate_out/detail/${payload}/`,
      {}
    );
    yield put(gateOutByIDSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* VehicleDataGet({ payload }) {
  try {
    const response = yield call(getList, "/masters/vehicles/" + payload, {});
    yield put(vehicleDataSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* FormulaExecuter({ payload }) {
  let systemFormulasList = yield select(
    (state) => state.system.systemFormulasList
  );

  try {
    var formulaObj = systemFormulasList?.find((formula) => {
      return formula?.code === payload.code;
    });

    if (formulaObj) {
      var result = evaluate(formulaObj.formula, payload.variables);

      if (result !== "NaN") {
        yield put(
          FormulaExecuterSuccessful({
            response: result,
            formulaCode: payload.code,
          })
        );
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to calculator. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
    // try {
    //   const response = yield call(postAdd, "/system/formulaexecuter/", payload);
    //   if (response.status === 200) {
    //     yield put(
    //       FormulaExecuterSuccessful({
    //         response: response.data,
    //         formulaCode: payload.code,
    //       })
    //     );
    //   } else {
    //     Modal.error({
    //       icon: (
    //         <span className="remix-icon">
    //           <RiAlertLine />
    //         </span>
    //       ),
    //       title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
    //       content: (
    //         <div>
    //           <p className="hp-p1-body hp-text-color-black-80">
    //             Sorry! Unable to calculator. Please try again!
    //           </p>
    //         </div>
    //       ),
    //     });
    //   }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}
function* PurchasesImageUpload({ payload }) {
  try {
    const response = yield call(postFormData, "/system/attachment/", {
      file: payload.file,
    });

    yield put(
      purchasesImageUploadSuccessful({ response, ImageType: payload.imageType })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GateInDelete({ payload }) {
  try {
    const response = yield call(
      postDelete,
      `/godown/gate_in/detail/${payload.id}/`
    );

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Gate Out Vehicle has been deleted!
            </p>
          </div>
        ),
      });

      yield put(getGateOutList({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),

        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Gate Out Vehicle has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

// Repair Amount

function* RepairAmount({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/stocktransfer/repairamount/bypurchaseid/" + payload.id,
      {}
    );
    yield put(repairAmountListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Re Estimation

function* ReEstimation({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/stocktransfer/reestimationamount/bypurchaseid/" + payload.id,
      {}
    );
    yield put(reEstimationListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* InsuranceValidate({ payload }) {
  try {
    const response = yield call(
      postAdd,
      "/purchase/insurancenumber/validation/",
      payload
    );
  } catch (error) {
    if (error.response.status == 400) {
      yield put(
        InputChangeValue({
          key: "insurancenumber",
          value: "",
        })
      );
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {error.response?.data?.error[0]}
            </p>
          </div>
        ),
      });
    } else if (error.response.status == 500) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Getting from server side issue!
            </p>
          </div>
        ),
      });
    }
    yield put(apiError(error));
  }
}

function* UpdateFsyncStatus({ payload }) {
  let purchaseParamsData = yield select(
    (state) => state.purchase.purchaseParams
  );
  try {
    const response = yield call(postEdit, "/purchase/reapprove/" + payload.id, {
      approvalstatus: payload.approvalstatus,
    });
    if (response.status === 200) {
      if (response.data.post_status == true) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Selected Gate Out Vehicle is successfully synchronised into
                focus
              </p>
            </div>
          ),
        });
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! selected Gate Out Vehicle is not posted on focus. please
                try again!
              </p>
            </div>
          ),
        });
      }
      yield put(getGateOutList(purchaseParamsData));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! selected Gate Out Vehicle is not posted on focus. please
              try again!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* VehicleImagesByID({ payload }) {
  try {
    const response = yield call(
      getParamsList,
      `/godown/gateoutvehicleimages/detail/${payload}`
    );
    yield put(
      vehicleImagesByIDSuccessful({ response, response2: payload.response2 })
    );

    // yield put(isModelVisible(true));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* gateInImageImageUpload({ payload }) {
  try {
    const response = yield call(postFormData, "/system/attachment/", {
      file: payload.file,
    });

    yield put(
      gateInImageUploadSuccessful({ response, ImageType: payload.imageType })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}
function* OTPRequest({ payload }) {
  try {
    const response = yield call(postAdd, "/system/temp_otp/request/", payload);
    if (response.status === 201) {
      yield put(personOTPRequestSuccessful(response.data));
      yield put(personOTPModelWithOutReq(response.data))
    }
  } catch (error) {
    yield put(apiError(error));
  }
}
function* OTPResend({ payload }) {
  try {
    const response = yield call(postAdd, "/system/temp_otp/resend/", payload);
    if (response.status === 200) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {response.data?.message}
            </p>
          </div>
        ),
      });
      yield put(personOTPResendSuccessful(response.data));
    }
  } catch (error) {
    if (error.response.status === 406) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),

        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {error.response.data?.detail}
            </p>
          </div>
        ),
      });
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),

        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Getting from server side issue!
            </p>
          </div>
        ),
      });
    }
    yield put(apiError(error));
  }
}
function* verifyOTP({ payload }) {
  let gateOutData = yield select((state) => state.gateOut.gateOutData);
  const purchaseObj = {
    status_id: gateOutData?.id ? gateOutData?.id : 0,
    // id: id == 0 ? props.gateOutData.vehicle_id?.vehicle_id : id,
    gate_in_id: gateOutData?.vehicle_id?.vehicle_id,
    godown_id: gateOutData.godown_id.godown_id,
    lot_no: gateOutData?.lotno,
    out_description: gateOutData?.description,
    reason: gateOutData?.reason_id?.id,
  };
  if (payload.OTPData?.otp) {
    purchaseObj.otp = payload.OTPData?.otp;
  }
  const profileObj = {};
  if (gateOutData?.confirmation_image1?.uid) {
    profileObj.confirmation_image1 = gateOutData?.confirmation_image1;
  }
  if (gateOutData?.confirmation_image2?.uid) {
    profileObj.confirmation_image2 = gateOutData?.confirmation_image2;
  }
  if (gateOutData?.other_image?.uid) {
    profileObj.other_image = gateOutData?.other_image;
  }
  // if (gateOutData?.reason_id?.id == 3) {
  //   purchaseObj.to_godown_id = gateOutData?.to_godown_id?.to_godown_id;
  // }
  if (gateOutData?.godown_vehicle?.counter?.id) {
    purchaseObj.counter_id = gateOutData?.godown_vehicle?.counter?.id;
  }
  if (gateOutData?.godown_transfer_out_id) {
    purchaseObj.godown_transfer_out_id =
      gateOutData?.godown_transfer_out_id?.id;
  }
  if (gateOutData?.purchase_release?.id) {
    purchaseObj.purchase_release_id = gateOutData?.purchase_release?.id;
  }
  // if (gateOutData?.counter_id?.counter_id) {

  //   purchaseObj.counter_id = gateOutData?.counter_id?.counter_id;
  // }
  if (gateOutData?.seizing_release?.id) {
    purchaseObj.seizeing_release_id = gateOutData?.seizing_release?.id;
  }
  if (gateOutData?.is_godown_transferred) {
    purchaseObj.godown_transfer_out_id = gateOutData?.godown_transfer_out?.id;
  }
  try {
    const response = yield call(
      postAdd,
      "/system/temp_otp/verify/",
      payload.OTPData
    );
    if (response.status === 200) {
      yield put(verifyPersonOTPSuccessful(payload));

      yield put(
        addGateOut({
          purchaseObj,
          history,
          profileObj,
          mobile: payload.OTPData.mobile,
          is_phone_verified: true,
        })
      );
    }
  } catch (error) {
    if (error.response.status === 406) {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),

        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              {error.response.data?.detail}
            </p>
          </div>
        ),
      });
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),

        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Getting from server side issue!
            </p>
          </div>
        ),
      });
    }
    yield put(apiError(error));
  }
}
export function* watchGetGateOutList() {
  yield takeEvery("gateOut/getGateOutList", GateOutList);
}
export function* watchGetGetGateInListById() {
  yield takeEvery("gateOut/getGateInListById", GateInListById);
}
export function* watchAddGateOut() {
  yield takeEvery("gateOut/addGateOut", GateOutAdd);
}
export function* watchGetPurchaseDoc() {
  yield takeEvery("gateOut/getPurchaseDoc", PurchaseDoc);
}
export function* watchGetGateOutByID() {
  yield takeEvery("gateOut/getGateOutByID", GetGateOutByID);
}
export function* watchGetVehicleData() {
  yield takeEvery("gateOut/getVehicleData", VehicleDataGet);
}
export function* watchGetFormulaExecuter() {
  yield takeEvery("gateOut/getFormulaExecuter", FormulaExecuter);
}
export function* watchGetPurchasesImageUpload() {
  yield takeEvery("gateOut/getPurchasesImageUpload", PurchasesImageUpload);
}
export function* watchGetPersonOTPRequest() {
  yield takeEvery("gateOut/personOTPRequest", OTPRequest);
}
export function* watchGetVerifyPersonOTP() {
  yield takeEvery("gateOut/verifyPersonOTP", verifyOTP);
}
export function* watchGetPersonOTPResend() {
  yield takeEvery("gateOut/personOTPResend", OTPResend);
}
export function* watchPurchaseApproval() {
  yield takeEvery("gateOut/purchaseApproval", PurchaseApproval);
}
export function* watchGetPurchaseCheckApprove() {
  yield takeEvery("gateOut/getPurchaseCheckApprove", PurchaseCheckApprove);
}

export function* watchGetPurchaseHistory() {
  yield takeEvery("gateOut/getPurchaseHistory", PurchaseHistory);
}

export function* watchGetSaleHistory() {
  yield takeEvery("gateOut/getSaleHistory", SaleHistory);
}
export function* watchGetPurchaseEnquiry() {
  yield takeEvery("gateOut/getPurchaseEnquiry", purchaseEnquiry);
}
export function* watchGetGateInDelete() {
  yield takeEvery("gateOut/gateInDelete", GateInDelete);
}
export function* watchGetRepairAmount() {
  yield takeEvery("gateOut/getRepairAmount", RepairAmount);
}
export function* watchGetReEstimation() {
  yield takeEvery("gateOut/getReEstimation", ReEstimation);
}
export function* watchInsuranceNumberValidate() {
  yield takeEvery("gateOut/insuranceNumberValidate", InsuranceValidate);
}
export function* watchFsyncStatusUpdate() {
  yield takeEvery("gateOut/fsyncStatusUpdate", UpdateFsyncStatus);
}
export function* watchGetvehicleImagesByID() {
  yield takeEvery("gateOut/getvehicleImagesByID", VehicleImagesByID);
}
function* gateOutSaga() {
  yield all([
    fork(watchGetGateOutList),
    fork(watchGetGetGateInListById),
    fork(watchAddGateOut),
    fork(watchGetPurchaseDoc),
    fork(watchGetGateOutByID),
    fork(watchGetVehicleData),
    fork(watchGetPurchasesImageUpload),
    fork(watchGetFormulaExecuter),
    fork(watchPurchaseApproval),
    fork(watchGetPurchaseCheckApprove),
    fork(watchGetPurchaseHistory),
    fork(watchGetSaleHistory),
    fork(watchGetPurchaseEnquiry),
    fork(watchGetGateInDelete),
    fork(watchGetRepairAmount),
    fork(watchGetReEstimation),
    fork(watchInsuranceNumberValidate),
    fork(watchFsyncStatusUpdate),
    fork(watchGetvehicleImagesByID),
    fork(watchGetPersonOTPRequest),
    fork(watchGetVerifyPersonOTP),
    fork(watchGetPersonOTPResend),
  ]);
}

export default gateOutSaga;
